import { LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent } from './component/LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_AVAILABLE_BUNDLES_FOR_AFFECTED_DESCENDANTS_FORM } from '../../../webcomponents.constants';

export { LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_LICENSE_MONTHLY_AVAILABLE_BUNDLES_FOR_AFFECTED_DESCENDANTS_FORM,
  LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent
);
